// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"styles_modal-body_98A28MWp6bD31unguXhCh","modalBody":"styles_modal-body_98A28MWp6bD31unguXhCh"};